import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicButton from '../BasicButton';

const ApplyPositionForm = ({
  onApplyHandler,
  onRefuseHandler,
  message = 'Do you want to apply for this position?',
}) => {
  return (
    <div className="apply-position-form">
      <div className="apply-position-form__text">{message}</div>

      <div className="apply-position-form__buttons">
        <div className="apply-position-form__button">
          <BasicButton
            btnWidth={85}
            btnHeight={35}
            btnFontSize="0.8571rem"
            btnFontWeight={600}
            btnText="Yes"
            btnArrow={false}
            controlFunc={onApplyHandler}
          />
        </div>

        <div className="apply-position-form__button">
          <BasicButton
            btnWidth={85}
            btnHeight={35}
            btnFontSize="0.8571rem"
            btnFontWeight={600}
            btnText="No"
            btnArrow={false}
            controlFunc={onRefuseHandler}
            btnBg="#fff"
            btnHoverBg="#f40"
          />
        </div>
      </div>
    </div>
  );
};

ApplyPositionForm.defaultProps = {
  onApplyHandler: () => {},
  onRefuseHandler: () => {},
};

ApplyPositionForm.propTypes = {
  onApplyHandler: PropTypes.func,
  onRefuseHandler: PropTypes.func,
};

export default ApplyPositionForm;
